import React, { useEffect } from "react";
import { NavigationBase } from "@reusejs/react";
import ThinHeader from "./ThinHeader";
import Logo from "./Logo";
import Navigations from "./Navigations";
import NavButtons from "./NavButtons";
import Sidebar from "./Sidebar";
import { useRouter } from "next/router";
import { useSelector, useDispatch } from "react-redux";
import {
  googleLoginWithToken,
  getUser,
  checkAndUpdateBidder,
  getSubscriptionByUserUuid,
} from "services";
import { setTokens, setUser, setSubscription, setRedirectUrl } from "store";
import { parse } from "cookie";

export default function Header(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const userToken = useSelector((state: any) => {
    return state.auth.accessToken;
  });
  const redirectUrl = useSelector((state: any) => {
    return state.auth.redirectUrl;
  });

  useEffect(() => {
    if (router) {
      if (router.pathname === "/[slug]/[id]" || router.pathname === "/[slug]") {
        dispatch(setRedirectUrl(router.asPath));
      } else {
        dispatch(setRedirectUrl(router.pathname));
      }
    }
  }, [router]);

  useEffect(() => {
    if (!userToken) {
      // if (window && window.google) {
      //   window.google.accounts.id.initialize({
      //     client_id: `${process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}`,
      //     itp_support: true,
      //     callback: async (tokenResponse) => {
      //       const data = await googleLoginWithToken({
      //         id_token: tokenResponse?.credential,
      //       });
      //       await fetch("/api/login", {
      //         method: "POST",
      //         headers: { "Content-Type": "application/json" },
      //         body: JSON.stringify({ accessToken: data }),
      //       });
      //       dispatch(setTokens(data));
      //       const user: any = await getUser();
      //       dispatch(setUser(user));
      //       const validateBidderEmail = await checkAndUpdateBidder(
      //         user?.attributes[0]?.value,
      //         user?.uuid
      //       );
      //       const subscription = await getSubscriptionByUserUuid(user?.uuid);
      //       if (subscription) {
      //         dispatch(setSubscription(subscription));
      //       }
      //       if (redirectUrl) {
      //         router.push(redirectUrl);
      //       } else {
      //         router.push("/");
      //       }
      //     },
      //   });
      //   window.google.accounts.id.prompt((notification) => {
      //     if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
      //       console.log(
      //         "check here reason why popup didn't displayed:",
      //         notification.getNotDisplayedReason()
      //       );
      //       // try next provider if OneTap is not displayed or skipped
      //     }
      //   });
      // }
    } else if (userToken) {
      const cookieValue = document.cookie;
      const cookies = parse(cookieValue);
      (async () => {
        if (!cookies.access_token) {
          const res = await fetch("/api/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ accessToken: { access_token: userToken } }),
          });
        }
      })();
    }
  }, [userToken, redirectUrl]);

  return (
    <div className="mb-16 lg:mb-[64px] ">
      {/* <div className="hidden lg:flex">
        <ThinHeader />
      </div> */}
      <NavigationBase
        left={Logo}
        middle={Navigations}
        right={NavButtons}
        sidebar={Sidebar}
        backgroundClasses="bg-white fixed top-0 left-0 w-full z-10"
        widthClasses="mx-auto w-full px-8"
        leftArrangement="none"
        middleArrangement="ml-8 z-30"
        rightArrangement="flex-1 justify-end w-64"
        borderClasses="relative border-b border-gray-200"
      />
    </div>
  );
}
